import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { DebugDiv } from '../../../../../components/Debug';
import { HermesysColors } from '../../../Colors';
import EventContext from '../../../context/EventContext';
import { ButtonPosition, ButtonPositionContext, MenuItem } from '../Console';
import usePopup from '../hooks/usePopup';
import { formatLabel, MenuButtonContainer, MenuButtonProps } from '../MenuButton';
import Scroller from '../Scroller';

const RightGrayPatch = styled.div`
  width: 20px;
  height: 10px;
  background: gray;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 4;
`;
const RightWhitePatch = styled.div`
  width: 20px;
  height: 10px;
  background: white;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
`;

const LeftGrayPatch = styled.div`
  width: 20px;
  height: 10px;
  background: gray;
  position: absolute;
  top: 2px;
  left: 5px;
  z-index: 4;
`;
const LeftWhitePatch = styled.div`
  width: 20px;
  height: 10px;
  background: white;
  position: absolute;
  top: 5px;
  left: 2px;
  z-index: 3;
`;

const PopupDiv = styled.div`
  background: ${HermesysColors.ButtonBackgroundGray};
  border: outset 3px ${HermesysColors.White};

  text-align: left;
`;

const PopupInnerDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 104px;
  overflow: hidden;
`;

const PopupItems = styled.div<any>`
  padding: 5px;
  text-transform: capitalize;
  ${({ selected }) => {
    if (selected) {
      return `
      background: ${HermesysColors.Blue};
      color: ${HermesysColors.White};
      `;
    }
  }}
`;

const ColoredText = styled.div`
  color: ${HermesysColors.Blue};
`;

const getDirection = (context) => {
  if (context.indexOf(ButtonPosition.BottomPanel) !== -1) {
    if (context.indexOf(ButtonPosition.LeftPanel) !== -1) {
      return 'bottom-right';
    } else if (context.indexOf(ButtonPosition.RightPanel) !== -1) {
      return 'bottom-left';
    }
    return 'bottom';
  }
  if (context.indexOf(ButtonPosition.LeftPanel) !== -1) {
    return 'right';
  }
  return 'left';
};

const ListButton = ({ item, buttonIdentifier }: MenuButtonProps) => {
  const contextValue = useContext(ButtonPositionContext);
  const { registerEvent, unRegisterEvent } = useContext(EventContext);
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<any>(null);

  const [showPopper, setShowPopper] = useState(false);
  const onClick = () => {
    setShowPopper((val) => !val);
  };
  useEffect(() => {
    const id = registerEvent(`click-${buttonIdentifier}`, onClick);
    return () => {
      unRegisterEvent(`click-${buttonIdentifier}`, id);
    };
  }, []);

  const { styles, show, hide } = usePopup(
    'console-display-area',
    referenceElement,
    popperElement,
    {
      direction: getDirection(contextValue),
    }
  );

  const val = item?.attributes?.value || '';

  useEffect(() => {
    if (showPopper) {
      show();
    } else {
      hide();
    }
  }, [showPopper]);

  return (
    <MenuButtonContainer clicked={showPopper} ref={setReferenceElement}>
      {contextValue.indexOf(ButtonPosition.LeftPanel) !== -1 && (
        <>
          <RightGrayPatch></RightGrayPatch>
          <RightWhitePatch></RightWhitePatch>
        </>
      )}
      {(contextValue.indexOf(ButtonPosition.RightPanel) !== -1 ||
        contextValue.indexOf(ButtonPosition.BottomPanel) !== -1) && (
        <>
          <LeftGrayPatch></LeftGrayPatch>
          <LeftWhitePatch></LeftWhitePatch>
        </>
      )}
      {formatLabel(item.label)}
      <ColoredText>
        <DebugDiv>{buttonIdentifier}</DebugDiv>
        {val}
      </ColoredText>
      {showPopper && (
        <PopupDiv style={{ ...styles }} ref={setPopperElement}>
          <Scroller>
            <PopupItems>one one one</PopupItems>
            <PopupItems selected>two two two</PopupItems>
            <PopupItems>three three three</PopupItems>
            <PopupItems>four four four</PopupItems>
            <PopupItems>five five five</PopupItems>
            <PopupItems>six six six</PopupItems>
          </Scroller>
        </PopupDiv>
      )}
    </MenuButtonContainer>
  );
};

export default ListButton;
